var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.551 501.551",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M83.592,501.551h311.38v-90.906H83.592c-1.045,0-3.135,0-4.18,1.045 c-1.045,0-3.135,1.045-3.135,1.045l-3.135,2.09l-42.841,25.078L1.045,456.62l29.257,16.718l42.841,25.078l3.135,2.09 c1.045,1.045,2.09,1.045,3.135,1.045C80.457,501.551,81.502,501.551,83.592,501.551z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M73.143,437.812h321.829v-27.167H83.592c-1.045,0-3.135,0-4.18,1.045 c-1.045,0-3.135,1.045-3.135,1.045l-3.135,2.09V437.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M83.592,501.551h311.38v-27.167H73.143v22.988l3.135,2.09c1.045,1.045,2.09,1.045,3.135,1.045 C80.457,501.551,81.502,501.551,83.592,501.551z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#334A5E"
    },
    points: "29.257,473.339 29.257,438.857 0,456.62 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M480.653,410.645h-58.514v90.906h58.514c11.494,0,20.898-9.404,20.898-20.898v-49.11 C501.551,420.049,492.147,410.645,480.653,410.645z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.143,
    y: 437.812,
    style: {
      fill: "#54C0EB"
    },
    width: 321.829,
    height: 36.571
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 394.135,
    y: 410.122,
    style: {
      fill: "#F2F2F2"
    },
    width: 28.212,
    height: 90.906
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M480.653,400.196H20.898C9.404,400.196,0,390.792,0,379.298V79.412h501.551v299.886 C501.551,390.792,492.147,400.196,480.653,400.196z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26.509,
    y: 104.866,
    style: {
      fill: "#FFFFFF"
    },
    width: 449.306,
    height: 268.539
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ACB3BA"
    },
    width: 501.551,
    height: 79.412
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F2F2F2"
    },
    cx: 123.298,
    cy: 39.706,
    r: 13.584
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F2F2F2"
    },
    cx: 78.367,
    cy: 39.706,
    r: 13.584
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15C"
    },
    cx: 34.482,
    cy: 39.706,
    r: 13.584
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M467.069,26.122h-202.71c-7.314,0-13.584,6.269-13.584,13.584s6.269,13.584,13.584,13.584h203.755 c7.314,0,13.584-6.269,13.584-13.584C480.653,32.392,474.384,26.122,467.069,26.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.71,
    y: 126.433,
    style: {
      fill: "#CDD6E0"
    },
    width: 251.82,
    height: 24.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.71,
    y: 178.678,
    style: {
      fill: "#CDD6E0"
    },
    width: 251.82,
    height: 24.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.71,
    y: 229.878,
    style: {
      fill: "#CDD6E0"
    },
    width: 251.82,
    height: 24.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.02,
    y: 282.122,
    style: {
      fill: "#CDD6E0"
    },
    width: 407.51,
    height: 24.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.02,
    y: 334.367,
    style: {
      fill: "#CDD6E0"
    },
    width: 407.51,
    height: 24.033
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M117.029,126.433H90.906L47.02,253.91h28.212l12.539-36.571h32.392l12.539,36.571h29.257 L117.029,126.433z M95.086,194.351l8.359-26.122v-1.045v1.045l8.359,25.078H95.086V194.351z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.13c9bb51b7d77a13681d9d11550dc668.svg";
export { ForwardRef as ReactComponent };